import { render, staticRenderFns } from "./ReporteParametrosAvg.vue?vue&type=template&id=b9365e88&scoped=true&"
import script from "./ReporteParametrosAvg.vue?vue&type=script&lang=js&"
export * from "./ReporteParametrosAvg.vue?vue&type=script&lang=js&"
import style0 from "./ReporteParametrosAvg.vue?vue&type=style&index=0&id=b9365e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9365e88",
  null
  
)

export default component.exports